goog.provide("shadow.js.shim.module$$tanstack$react_query");
goog.provide("module$shadow_js_shim_module$$tanstack$react_query");
shadow.js.shim.module$$tanstack$react_query = shadow.js.nativeProvides["@tanstack/react-query"] = shadow$bridge("@tanstack/react-query");
module$shadow_js_shim_module$$tanstack$react_query.default = shadow.js.shim.module$$tanstack$react_query;
